import React from 'react'
import StandardTaskForm from '../../components/standardtaskcomponents/StandardTaskForm'
import { useDispatch } from 'react-redux';
import { setHeaderName } from '../../redux/actions/userActions';

const StandardTask = () => {
    const dispatch = useDispatch();
    dispatch(setHeaderName('SET_HEADER_NAME', 'Hospital Masters'));
    return <StandardTaskForm />

}

export default StandardTask